let appType = '';
appType = 'REPLACE_TO_APPLICATION_TYPE';
let isProduction = 'REPLACE_TO_PRODUCTION';
export const environment = {
  production: isProduction === 'true' ? 'true' : 'false',
  datasheet: appType === 'anflexWeb' ? false : true,
  anflexWeb: appType === 'anflexWeb' ? true : false,
  storage_server_service_url: 'REPLACE_TO_STORAGE_SERVICE_ADDRESS',
  catenary_generation_service_url: 'REPLACE_TO_CATENARY_SERVICE_ADDRESS',
  aml_loader_service_url: 'REPLACE_TO_AML_SERVICE_ADDRESS',
  user_management_service_url: 'REPLACE_TO_USER_SERVICE_ADDRESS',
  datasheet_storage_server_url: 'REPLACE_TO_DATASHEET_STORAGE_ADDRESS',
  subweb_url: 'REPLACE_TO_SUBWEB_ADDRESS',
  fraes_url: 'REPLACE_TO_FRAES_ADDRESS',
};
